import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageHero({ title, accent, desc, breadcrumbs = [] }) {
  return (
    <section className="relative bg-gray-900 pt-14 pb-12 overflow-hidden">
      {/* Grid overlay */}
      <div className="absolute inset-0 opacity-5"
        style={{backgroundImage:'linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px)',backgroundSize:'48px 48px'}}/>
      {/* Red glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-red-600/20 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"/>
      <div className="absolute bottom-0 right-0 h-0.5 left-0 bg-red-600"/>

      <div className="relative max-w-7xl mx-auto px-6">
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-gray-500 mb-4">
            <Link to="/" className="hover:text-red-400 transition-colors">Hem</Link>
            {breadcrumbs.map((b, i) => (
              <React.Fragment key={i}>
                <ChevronRight size={10} className="text-gray-600"/>
                {b.to ? <Link to={b.to} className="hover:text-red-400 transition-colors">{b.label}</Link> : <span className="text-gray-400">{b.label}</span>}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className="font-display font-black text-4xl md:text-6xl text-white uppercase tracking-tight leading-none mb-3">
          {title} {accent && <span className="text-red-400">{accent}</span>}
        </h1>
        {desc && <p className="text-gray-400 text-base max-w-xl leading-relaxed">{desc}</p>}
      </div>
    </section>
  );
}
